export interface MenuConfigItem {
    id: string;
    label: string;
    icon?: string;
    link?: string;
    // The permission object should reference a module name that exists in your subscription JSON.
    permission: {
        module: string;
        action: string;
    };
    // featureKey should match the specific feature key in your subscription JSON for the given module.
    featureKey?: string;
    disabledTooltip?: string;
    subItems?: MenuConfigItem[];
    isHeader?: boolean;
    parentId?: string;
}

export const MENU_CONFIG: MenuConfigItem[] = [
    {
        id: "dashboards",
        label: "Dashboards",
        icon: "ri-dashboard-2-line",
        link: "/dashboard",
        // For the parent item, if you want the detailed granular check to occur,
        // set featureKey to a key that your subscription JSON defines.
        // For example, if your JSON has under "dashboards" a feature "overview":
        featureKey: "dashboards",
        permission: { module: "dashboards", action: "dashboards" }
    },
    {
        id: "students",
        label: "Students",
        icon: "ri-list-check",
        link: "/students",
        // Assuming your subscription JSON has a module "students" with a feature "list"
        permission: { module: "students", action: "students" },
        featureKey: "students"
    },
    {
        id: "applications",
        label: "Applications",
        icon: "ri-contacts-book-line",
        link: "/applications",
        // If you plan to control access via subscription for applications, ensure
        // your subscription JSON uses matching keys. Otherwise, you could leave
        // featureKey undefined to rely on a fallback check.
        permission: { module: "applications", action: "applications" },
        featureKey: "applications"
    },
    {
        id: "institutes",
        label: "Institutes",
        icon: "ri-building-4-line",
        link: "/institutes",
        permission: { module: "institutes", action: "institutes" },
        featureKey: "institutes"
    },
    {
        id: "courses",
        label: "Courses",
        icon: "ri-book-open-line",
        link: "/courses",
        permission: { module: "courses", action: "courses" },
        featureKey: "courses"
    },
    {
        id: "finances",
        label: "Finances",
        icon: "ri-contacts-book-line",
        link: "/#",
        permission: { module: "finances", action: "finances" },
        // Here we use a featureKey that corresponds to the primary feature for finances.
        // For instance, if your subscription JSON defines "invoices" under the "finances" module.
        featureKey: "finances",
        subItems: [
            {
                id: "invoices",
                label: "Invoices",
                link: "/invoices",
                parentId: "finances",
                permission: { module: "invoices", action: "invoices" },
                featureKey: "invoices"
            },
            {
                id: "payments",
                label: "Payments",
                link: "/payments",
                parentId: "finances",
                permission: { module: "Payments", action: "payments" },
                // If you have a separate feature for payments in your JSON, assign its key
                featureKey: "payments"
            },
            {
                id: "disputes",
                label: "Disputes",
                link: "/disputes",
                parentId: "finances",
                permission: { module: "disputes", action: "disputes" },
                // If disputes require an upgrade, you can also add a custom tooltip:
                featureKey: "disputes",
                disabledTooltip: "Please upgrade your subscription to access this feature."
            },
        ]
    },
    {
        id: "sources",
        label: "Sources",
        icon: "ri-team-line",
        link: "/sources",
        permission: { module: "sources", action: "sources" },
        featureKey: "sources"
    },
    {
        id: "subagents",
        label: "Sub Agents",
        icon: "ri-team-line",
        link: "/subagents",
        permission: { module: "subagents", action: "subagents" },
        featureKey: "subagents"
    },
    {
        id: "channels",
        label: "Channels",
        icon: "ri-group-line",
        link: "/channels",
        permission: { module: "channels", action: "channels" },
        featureKey: "channels"
    },
    {
        id: "fields",
        label: "Fields",
        icon: "ri-list-settings-line",
        link: "/fields",
        permission: { module: "fields", action: "fields" },
        featureKey: "fields"
    },
    {
        id: "users",
        label: "Users",
        icon: "ri-user-line",
        link: "/users",
        permission: { module: "users", action: "users" },
        featureKey: "users"
    },
    {
        id: "roles",
        label: "Roles",
        icon: "ri-user-settings-line",
        link: "/roles",
        permission: { module: "roles", action: "roles" },
        featureKey: "roles"
    },
    {
        id: "teams",
        label: "Teams",
        icon: "ri-user-settings-line",
        link: "/teams",
        permission: { module: "teams", action: "teams" },
        featureKey: "teams"
    },
    {
        id: "companies",
        label: "Companies",
        icon: "ri-user-settings-line",
        link: "/companies",
        permission: { module: "companies", action: "companies" },
        featureKey: "companies"
    },
    {
        id: "forms",
        label: "Forms",
        icon: "ri-book-open-line",
        link: "/forms",
        permission: { module: "forms", action: "forms" },
        featureKey: "forms"
    },
    {
        id: "products",
        label: "Products",
        icon: "ri-rocket-line",
        link: "/products",
        permission: { module: "products", action: "products" },
        featureKey: "products"
    },
    {
        id: "templates",
        label: "Templates",
        icon: "ri-user-settings-line",
        link: "/templates",
        permission: { module: "templates", action: "templates" },
        featureKey: "templates"
    },
    {
        id: "reports",
        label: "Reports",
        icon: "ri-user-settings-line",
        link: "/reports",
        permission: { module: "reports", action: "reports" },
        featureKey: "reports"
    },
    {
        id: "imports",
        label: "Recent Imports",
        icon: "ri-file-upload-line",
        link: "/recent-import",
        permission: { module: "imports", action: "imports" },
        featureKey: "imports"
    },
    {
        id: "audits",
        label: "Activity Footprints",
        icon: "ri-footprint-line",
        link: "/footprints",
        permission: { module: "audits", action: "audits" },
        featureKey: "audits"
    }
];
